import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { CLIENTS } from "../../constants/testIds";
import { Button } from "../../components/ui/button";
import { Plus, Building2 } from "lucide-react";

export default function ClientsList() {
    const [clients, setClients] = useState([]);
    const nav = useNavigate();
    useEffect(() => {
        api.get("/clients").then((r) => setClients(r.data));
    }, []);
    return (
        <div data-testid={CLIENTS.root} className="space-y-8">
            <div className="flex items-end justify-between gap-4">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.18em] text-muted mb-2">Admin</div>
                    <h1 className="font-extrabold tracking-[-0.03em] text-4xl leading-none">Clients</h1>
                    <p className="text-muted mt-2 num">{clients.length} on file</p>
                </div>
                <Button
                    data-testid={CLIENTS.newBtn}
                    onClick={() => nav("/admin/clients/new")}
                    className="gap-2"
                >
                    <Plus size={16} /> New client
                </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {clients.map((c) => (
                    <button
                        key={c.id}
                        data-testid={CLIENTS.row(c.id)}
                        onClick={() => nav(`/admin/clients/${c.id}`)}
                        className="km-card p-5 text-left hover:border-[color:var(--km-accent)]/40 transition-colors"
                    >
                        <div className="flex items-start justify-between mb-3">
                            <div className="w-10 h-10 rounded-md bg-[color:var(--km-forest)]/10 flex items-center justify-center">
                                <Building2 size={18} className="text-forest" strokeWidth={1.5} />
                            </div>
                            <span className="text-[10px] uppercase tracking-[0.14em] text-muted">Client</span>
                        </div>
                        <div className="font-medium text-ink">{c.name}</div>
                        <div className="text-sm text-muted mt-1">{c.contact_name || "—"}</div>
                        <div className="text-xs text-muted mt-3 truncate">{c.address}</div>
                    </button>
                ))}
                {!clients.length && (
                    <div className="col-span-full text-center text-muted py-12">
                        No clients yet.
                    </div>
                )}
            </div>
        </div>
    );
}
